export default "__VITE_ASSET__B_3P7FWD__"